import { MeasurementDetails as MeasurementDetails1 } from "@/components/report/MeasurementDetails";
import MeasurementDetails2, {
  MeasurementDetailsResponse2,
} from "@/components/report/MeasurementDetails2";
import {
  MeasurementDetailsResponse,
  ReportPageBaseProps,
} from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { usePageUserType } from "@/utils/router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function MeasurementDetailsPage({ setIndicator }: ReportPageBaseProps) {
  const { uuid } = useParams();
  const userType = usePageUserType();
  const axios = useAxios();
  const [data, setData] = useState<{ publish_version: string } | null>(null);
  useEffect(() => {
    (async () => {
      const response = await axios.get(
        `/api/report/${uuid}/measurement_details`
      );
      setData(response.data);
      setIndicator(false);
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null || data == null) return <></>;

  switch (data.publish_version) {
    case "1.0":
    case "1.1":
      // PDF版
      return <></>;
    case "2.0":
    case "3.0":
    case "3.1":
      // 旧Webレポート
      return (
        <MeasurementDetails1
          data={data as MeasurementDetailsResponse}
          userType={userType}
          uuid={uuid}
        />
      );
    case "4.0":
    default:
      // Webレポート改善版
      return (
        <MeasurementDetails2
          data={data as MeasurementDetailsResponse2}
          userType={userType}
          uuid={uuid}
        />
      );
  }
}
